"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VengefulHowlAbilityHandler = exports.VengefulHowlActorAbilityFactory = exports.VengefulHowlAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const enums_1 = require("../../core/enums");
const core_1 = require("../../core/effects/core");
const Enum_1 = require("../../utils/Enum");
class VengefulHowlAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.VengefulHowl;
        this.__typeName = "VengefulHowl";
    }
}
exports.VengefulHowlAbilityArgs = VengefulHowlAbilityArgs;
let VengefulHowlActorAbilityFactory = class VengefulHowlActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("VengefulHowl", "Self", 4);
    }
};
VengefulHowlActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("VengefulHowl")
], VengefulHowlActorAbilityFactory);
exports.VengefulHowlActorAbilityFactory = VengefulHowlActorAbilityFactory;
let VengefulHowlAbilityHandler = class VengefulHowlAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                for (const targetId of container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)) {
                    container.applyBuffs({
                        sequence,
                        creatorId: ability.invokerId,
                        targetId,
                        effects: [
                            enums_1.AttributeType.Power,
                            enums_1.AttributeType.Focus
                        ].map(attr => ({
                            duration: Duration_1.Duration.Turns(4),
                            effect: new core_1.MaxAttributeIncreaseEffectArgs(attr, container.getPercentOfBaseAttributeScore(targetId, 10, (0, Enum_1.enumKey)(enums_1.AttributeType, attr)))
                        }))
                    });
                }
            }
        });
    }
};
VengefulHowlAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.VengefulHowl)
], VengefulHowlAbilityHandler);
exports.VengefulHowlAbilityHandler = VengefulHowlAbilityHandler;
